import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Search, Car, FileCheck, Key } from "lucide-react";

const steps = [
  { icon: Search, title: "Recherchez", text: "Choisissez votre ville et vos dates pour découvrir les véhicules disponibles." },
  { icon: Car, title: "Choisissez", text: "Comparez les offres des agences locales vérifiées et sélectionnez votre véhicule." },
  { icon: FileCheck, title: "Réservez", text: "Complétez votre profil, versez l'acompte et signez le contrat en ligne." },
  { icon: Key, title: "Roulez", text: "Récupérez le véhicule à l'aéroport ou sur place et voyagez en toute sérénité." },
];

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      <SiteHeader />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8 text-center">
        <div className="text-xs uppercase tracking-[0.2em] text-[#0e7a3f] font-bold">Comment ça marche</div>
        <h1 className="font-display text-4xl md:text-5xl font-black text-[#0a1e3f] mt-2">Une réservation en 4 étapes</h1>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-5">
        {steps.map((s, i) => (
          <div key={s.title} className="bg-white rounded-3xl p-6 border border-gray-100 mbk-card-shadow">
            <div className="h-12 w-12 rounded-2xl bg-[#0a1e3f] text-[#d4a437] flex items-center justify-center"><s.icon className="h-6 w-6" /></div>
            <div className="mt-4 text-xs font-bold text-gray-400">ÉTAPE {i + 1}</div>
            <div className="font-display text-xl font-black text-[#0a1e3f]">{s.title}</div>
            <p className="text-sm text-gray-600 mt-2 leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
      <SiteFooter />
    </div>
  );
}
